import { __assign } from "tslib";
import * as React from 'react';
import AnimatableDiv from './AnimatableDiv';
import { mouseEventProps } from './mouseEventProps';
import { joinClass } from './symbolUtils';
export var Scene = function (_a) {
    var children = _a.children, conditionalState = _a.conditionalState, inEditor = _a.inEditor, symbol = _a.symbol, timelineRefId = _a.timelineRefId;
    var _b = mouseEventProps(symbol, inEditor), clickClass = _b.clickClass, mouseEventStyles = _b.mouseEventStyles, onClick = _b.onClick;
    var styles = conditionalState.styles;
    var className = joinClass(symbol.id, conditionalState.id, clickClass);
    return (React.createElement(AnimatableDiv, { className: className, id: timelineRefId, onClick: onClick, style: __assign(__assign({}, mouseEventStyles), styles), inEditor: inEditor }, children));
};
export default Scene;
